import React from 'react';

const CommerceApiContent = () => (
  <div className="animate-fadeIn">
    <h2 className="text-2xl font-semibold mb-6 flex items-center gap-2">
      <span className="p-2 bg-blue-500/20 rounded-lg text-blue-400 text-sm">POST</span> 
      Document Flow API
    </h2>
    <p className="text-gray-400 mb-8">Esta API permite rastrear el flujo de documentos (PO, Receipt, Invoice) dentro de la red.</p>
    
    <div className="bg-black/40 rounded-xl p-6 font-mono text-sm border border-white/5">
       <p className="text-green-400">// Ejemplo de Request</p>
       <pre className="text-gray-300 mt-2">
{`{
  "documentId": "PO12345",
  "realm": "my-company-T",
  "type": "order"
}`}
       </pre>
    </div>
  </div>
);

export default CommerceApiContent; 